import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectdigitalPublicInfrastructuresListItems } from "../../../../../redux/digital-public-infrastructures/selector";
import { digitalPublicInfrastructures } from "../../../../../redux/digital-public-infrastructures/action";


const DigitalPublicInfrastructures = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
	const { header, footer, currency } = result
    const digitalPublicInfrastructuresItems = useSelector(selectdigitalPublicInfrastructuresListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name',searchField: 'Name', filter: true,
            filterType: 'text' },
          { field: 'Service', headerName: 'Service' ,searchField: 'Service', filter: true,
            filterType: 'text'},
          { field: 'Cost', headerName: 'Cost', isCurrencyValueFormat:true},
          { field: 'IsEnabled', headerName: 'Enabled', cellRenderer: 'yesNoRenderer' },
          { field: 'IsParent', headerName: 'Parent', cellRenderer: 'yesNoRenderer' }
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(digitalPublicInfrastructures.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-Public-infrastructures/list`,entity:'digitalPublicInfrastructures',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
      }
    
      const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
      }

      const handleReloadData = () => {
        dispatch(digitalPublicInfrastructures.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-Public-infrastructures/list`,entity:'digitalPublicInfrastructures',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchDigitalPublicInfrastructuresItems=()=>{
        dispatch(digitalPublicInfrastructures.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-Public-infrastructures/list`,entity:'digitalPublicInfrastructures',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const additionButtons: any = [
          {
            svg:
             <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
               <title>Add DigitalPublicInfrastructure</title>
               <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
             </svg>,
           callback: () => handleAdd(),
         },
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
	useEffect(() => {
        createColumnDefs()
        fetchDigitalPublicInfrastructuresItems()
	}, [pageData,pageSize])
  const handleDelete=(data: any)=>{
    dispatch(digitalPublicInfrastructures.delete({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-Public-infrastructures/delete`,
      entity: 'digitalPublicInfrastructures',
      jsonData: {
        Records: [
          {
         
                Id: data?.Id
            }
          
        ]
      }
  })).then(() => {
    dispatch(digitalPublicInfrastructures.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-Public-infrastructures/list`,entity:'digitalPublicInfrastructures',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
	return (
    <>
    {digitalPublicInfrastructuresItems?.isLoading ?  <PageLoader />: 
		<Table   enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={digitalPublicInfrastructuresItems?.result?.items} setPageData={setPageData}
    setPageSize={setPageSize}paginationData={digitalPublicInfrastructuresItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete}headingName="DigitalPublicInfrastructures"/>
     
  }
  </> 
	);
};

export default DigitalPublicInfrastructures;


